import etapasRotas from './etapas/EtapasRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'financeiro',
    name: 'Sgtec_Financeiro',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [...etapasRotas, pagamentosRotas]
}
